export const label = [
    "ISMS",
    "APP",
    "SYS",
    "IND",
    "NET",
    "INF",
    "DER",
    "OPS",
    "CON",
    "ORP"
]

export const label2 = [
    "ISMS",
    "ORP",
    "CON",
    "OPS",
    "DER",
    "APP",
    "SYS",
    "IND",
    "NET",
    "INF"
]

export const recommended = {
    "borderColor": "#b2e061",
    "pointBackgroundColor": "#b2e061",
    "data": [
        2.5,
        2.5,
        2.5,
        2.5,
        2.5,
        2.5,
        2.5,
        2.5,
        2.5,
        2.5]
}


export const chartData = {
    labels: label,
    "datasets": [
        {
            "borderColor": "#0066ff",
            "pointBackgroundColor": "#0066ff",
            "data": []
        },
    ]
}

export const benchmarkChart = {
    labels: label2,
    "datasets": [
        {
            "borderColor": "#0066ff",
            "pointBackgroundColor": "#0066ff",
            "data": []
        },
    ]
}
export const levelsChart = {
    "labels": label2,
    "datasets": [
        {
            "borderColor": "#0066ff",
            "pointBackgroundColor": "#0066ff",
            "data": [],
            "label": ""
        },
        {
            "borderColor": "#ffb55a",
            "pointBackgroundColor": "#ffb55a",
            "data": [],
            "label": ""
        },
        {
            "borderColor": "#301934",
            "pointBackgroundColor": "#301934",
            "data": [],
            "label": ""
        },
        {
            "borderColor": "#b2e061",
            "pointBackgroundColor": "#b2e061",
            "data": [],
            "label": ""
        }
    ]
}


export const chartOptions = {
    "responsive": true,
    "borderColor": "#0066ff",
    "pointBackgroundColor": "#0066ff",
    "fill": false,
    "scales": {
        "r": {
            "startAngle": -18.5,

            "grid": {
                "circular": true
            },
            "beginAtZero": true
        }
    },
    "plugins": {
        "legend": {
            "display": true
        }
    },
    "scale": {
        "max": 3.0,
        "min": 0.0
    }
}


export const chartOptionsLine = {
    "responsive": true,
    "scale": {
        "y": {
        "max": 3.0,
        "min": 0.0
        }
    }
}